/* src/app/main/claim-data/wizard/claim-data-wizard.component.scss */
h3 {
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: normal;
  color: #002c77;
}
.data-preview-container-step1 {
  margin: 20px 0 30px;
  overflow-x: auto;
}
.input-container-step1 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 30px;
}
.input-field-step1 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.input-field-step1 label {
  min-width: 120px;
  font-weight: normal;
}
.input-field-step1 input {
  width: 160px;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.input-field-step1 input:hover,
.input-field-step1 input:focus {
  border-color: #006f8a;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
  outline: none;
}
.error-message-step1 {
  color: red;
  font-size: 14px;
}
.column-mapping-row {
  margin-bottom: 1rem;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 0.5rem;
}
.input-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 0.5rem;
}
.input-group label {
  min-width: 180px;
  font-weight: bold;
}
.input-group select,
.input-group input[type=text] {
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  width: 260px;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}
.input-group select:hover,
.input-group select:focus,
.input-group input[type=text]:hover,
.input-group input[type=text]:focus {
  border-color: #006f8a;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  outline: none;
}
.toggle-advanced {
  font-size: 0.9rem;
  color: #007bff;
  cursor: pointer;
  display: inline-block;
  margin-top: 4px;
}
.advanced-options {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}
.input-group-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.import-errors {
  margin-top: 15px;
  color: #a94442;
  background-color: #f2dede;
  padding: 10px;
  border-left: 4px solid #a94442;
}
.import-success {
  margin-top: 15px;
  color: #3c763d;
  background-color: #dff0d8;
  padding: 10px;
  border-left: 4px solid #3c763d;
}
.data-preview-table-step1 {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #ccc;
  table-layout: auto;
}
.data-preview-table-step1 th,
.data-preview-table-step1 td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: center;
}
.data-preview-table-step1 .col-number {
  background-color: #008ecc;
  color: white;
  font-weight: bold;
}
.data-preview-table-step1 .header-row {
  background-color: #6cc4ec;
  font-weight: bold;
}
.data-preview-table-step1 .row-number {
  background-color: #008ecc;
  color: white;
  font-weight: bold;
}
.data-preview-table-step1 .first-block-row:nth-child(even),
.data-preview-table-step1 .last-block-row:nth-child(even) {
  background-color: #eaf8ff;
}
.data-preview-table-step1 .first-block-row:nth-child(odd),
.data-preview-table-step1 .last-block-row:nth-child(odd) {
  background-color: #ffffff;
}
.data-preview-table-step1 .row-separator td {
  background-color: #006f8a;
  color: white;
  font-weight: bold;
  text-align: center;
}
/*# sourceMappingURL=claim-data-wizard.component-6GTM4WKC.css.map */
